import ReactDOM from "react-dom/client";
import App from "./App";
import "../src/assets/css/venjos.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import NoPage from "./components/pages/NoPage";
import Login from "./components/login/Login.jsx";
import Logout from "./components/login/logout";
import ChangePassword from "./components/header/changePs.js";
import EnmUserLogin from "./components/login/enmuserlogin.js";
import OptipredUser from "./components/login/optipreduser.js";
import SKUMaster from "./components/master/skumaster.js";
import PlantMaster from "./components/master/plantmaster.js";
import UserActions from "./components/master/useractions.js";
import DestinationMaster from"./components/master/destinationmaster.js";
import PlantDestinationMaster from "./components/master/plantdestinationmapping.js";
import PinMapping from "./components/master/pinmapping.js";
// import MasterConfigurations from "./components/master/master-configurations.js";
import HistoricSales from "./components/inventory/historicsales.js";
import HistoricData from "./components/inventory/historicdata.js";
import HistoricDataParent from "./components/inventory/historicdataparent.js";

// import DPMasters from "./components/inventory/dpmasters.js";
import DPMasters from "./components/inventory/dpmasters2.js";

import BatchMaster from "./components/inventory/batchmaster.js";
import MastersCalender from "./components/inventory/calender_master.js";
import CurrentStockStatus from "./components/inventory/currentstockstatus.js";
import CycleDaysIndentation from "./components/inventory/cycledaysindentation.js";
import CurrentStockIndentation from "./components/inventory/currentstockindentation.js";
// import RaisedOrders from "./components/inventory/raised-orders.js";
// import CreativeLoader from "./components/inventory/creativeloader.js";
// import SkuMasterCopy from "./components/inventory/skuMasterCopy.js";
// import SalesInsights from "./components/inventory/sales-insights-dashboard.js";
import HistoricSalesDashboard from "./components/inventory/historicsalesdashboard.js";
import HistoricSalesInsights from "./components/inventory/historicsalesinsights.js";
import InventoryConfiguration from "./components/inventory/inventory-configurations.js";
import FinishedGoodsInventory from "./components/inventory/finishedGoodsInventory.js";
import StockStatusParent from "./components/inventory/stock-status-fg/stock-status-parent.js";
import NewFinishedGoodsInventory from "./components/inventory/fginventory.js";
import Dashboards from "./components/inventory/dashboards.js";
// import PPTrackingDashboardApi from "./components/inventory/pptrackingdashboardapi.js";
import PPTrackingDashboard from "./components/inventory/pptrackingdashboardapi.js";
import IndentationCreation from "./components/inventory/indentaion-creation.js";
import DemandDistributionData from "./components/inventory/demand_distribution_data.js";
// import Dashboard from "./components/inventory/dashboard.js";
// import StockValidation from "./components/inventory/stockvalidation.js";
import ActiveSkus from "./components/indentation/activeskus.js";
import InventoryDashboards from "./components/inventory/inventory-dashboards.js";
import FGDashboard from "./components/inventory/fg-dashboard.js";
import OverviewDashboard from "./components/inventory/fg-dashboard2.js";
// import Test from "./components/test.js"
import CurrentStockDashboard from "./components/inventory/currentstockdashboards.js";
import WarehouseIndentation from "./components/indentation/warehouse-indentation.js";
import PathTracker from "./pathtracker.js";
import DarkstoresIndentaionTabs from "./components/inventory/darskstoresindentationtabs.js";
//Pm master
import PmSkuMaster from "./components/master/pmskumaster.js";
import ConversionMetric from "./components/master/conversionmetric.js";
import PmMapping from "./components/master/pmpinmapping.js";
import PmVendor from "./components/master/pmvendor.js";
import PmWhVendor from "./components/master/pmwhvendor.js";
import PmWarehouseMaster from "./components/master/pmwarehousemaster.js";
//Pm Inventory
// import WarehouseCurrentStock from "./components/inventory/warehousecurrentstock.js";
import PMstockParent from "./components/inventory/pmstockparent.js";
import PMInventory from "./components/inventory/pminventory.js";
import PMPoData from "./components/inventory/pmpodata.js";

import WhSkuCategoryNorms from "./components/inventory/whskucategorynorms.js";




import { Warehouse } from "lucide-react";


export default function Root() {
  return (
    <BrowserRouter>
    <PathTracker />
      <Routes>
        <Route exact path="/enmuserlogin/:token" element={<EnmUserLogin />} />
        <Route exact path="/optipreduser/:token" element={<OptipredUser />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/reset" element={<ChangePassword />} />
        
        <Route path="/" element={<App />}>
          {/* ---- Masters Screens ---- */}
          <Route path={"sku-master"} element={<SKUMaster />} />
          {/* <Route path={"sku-master-copy"} element={<SkuMasterCopy />} /> */}
          <Route path={"source-master"} element={<PlantMaster />} />
          <Route path={"destination-master"} element={<DestinationMaster />} />
          <Route path={"source-destination-mapping"} element={<PlantDestinationMaster />} />
          <Route path={"wh_sku_category_norms"} element={<WhSkuCategoryNorms/>} />

          <Route path={"dp-masters"} element={<DPMasters />} />
          <Route path={"calender-masters"} element={<MastersCalender />} />
          <Route path={"batch-master"} element={<BatchMaster />} />
          <Route path={"pin-mapping"} element={<PinMapping />} />

          {/* ---- Inventory Management Screens ---- */}
          <Route path={"fg-stock-status-old"} element={<CurrentStockStatus/>} />
          <Route path={"fg-stock-status"} element={<StockStatusParent />} />
          <Route path={"finished-goods-inventory-old"} element={<FinishedGoodsInventory />} />
          <Route path={"finished-goods-inventory"} element={<NewFinishedGoodsInventory />} />
          <Route path={"inventory-dashboards"} element={<InventoryDashboards />} />
          <Route path={"currentstock-dashboard"} element={<CurrentStockDashboard />} />
          {/* <Route path={"stock-validation"} element={<StockValidation/>} /> */}
          <Route path={"historic-sales-dashboard"} element={<HistoricSalesDashboard />} />
          <Route path={"historic-sales-insights"} element={<HistoricSalesInsights />} />
          {/* <Route path={"historic-sales"} element={<HistoricSales />} />
          <Route path={"historic-data"} element={<HistoricData />} /> */}
          <Route path={"historic-data"} element={<HistoricDataParent />} />


          <Route path={"pp-tracking-dashboard"} element={<PPTrackingDashboard />} />
        
          <Route path={"dashboards"} element={<Dashboards />} />

         



          {/* <Route path={"sales-insights"} element={<SalesInsights />} /> */}
          
          {/* ---- Indentation Management Screens ---- */}
          <Route path={"cycle-dates"} element={<CycleDaysIndentation/>} />
          <Route path={"darkstore-indentation"} element={<DarkstoresIndentaionTabs />} />
          <Route path={"warehouse-indentation"} element={<WarehouseIndentation />} />
          
          {/* <Route path={"stock-status"} element={<CurrentStockIndentation/>} />
          <Route path={"demand-distribution"} element={<DemandDistributionData />} />
          <Route path={"raised-indents"} element={<IndentationCreation />} />
          <Route path={"active-skus"} element={<ActiveSkus />} /> */}
          
          {/* ---- Configurations & Other ----*/}
          <Route path={"inventory-configurations"} element={<InventoryConfiguration />} />
          <Route path={"user-actions"} element={<UserActions />} />
          <Route path={"nopage"} element={<NoPage />} />
          {/* <Route path={"creativeLoader"} element={<CreativeLoader />} /> */}
          {/* <Route path={"master-configurations"} element={<MasterConfigurations />} /> */}
          <Route path="*" element={<Navigate to="/nopage" replace />} />

          {/* pm master */}

          <Route path={"pm-sku-master"} element={<PmSkuMaster />} />
          <Route path={"conversion-metric"} element={<ConversionMetric />} />
          <Route path={"pm-mapping"} element={<PmMapping />} />
          <Route path={"pm-vendor"} element={<PmVendor />} />
          <Route path={"warehouse-vendor"} element={<PmWhVendor />} />
          <Route path={"pm-warehouse"} element={<PmWarehouseMaster />} />
          {/* <Route path={"warehouse-current-stock"} element={<WarehouseCurrentStock/>} /> */}
          <Route path={"pm-stock-status"} element={<PMstockParent/>} />
          <Route path={"pm-inventory"} element={<PMInventory/>} />
          <Route path={"pm-po-data"} element={<PMPoData/>} />




          




        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
